const Images = {
	img1: require('./wireframe.png'), // Wireframe
	img2: require('./exitosalud.png'), // Exito Salud
	img3: require('./exitostay.png'), // Exito Stay
	img4: require('./catitogames.png'), // CatitoGames
	img5: require('./galaxy.png'), // Galaxy
	img6: require('./luxury-apt.png'), // Luxury Apartment
	img7: require('./olpc.png'), // Laptop
	img8: require('./premio.png'), // Premio
	img9: require('./quadmachine.png'), // Quad Machine
	img10: require('./Bose.png'), // Bose
	img11: require('./leddartech.png'), // Leddartech
	img12: require('./Shenda.png'), // Shenda
}

export default Images
